import React from 'react';
import { getT } from '../i18n';
import { formatApplicationNo, formatInterviewDate, getAppField } from '../utils/applicationFields';
import './ApplicationWaiting.css';

const ApplicationWaiting = ({
  lang = 'zh',
  application = null,
  onBack,
  onGoToMessages
}) => {
  const t = getT(lang);
  const ta = t.applicant;

  const rawInterviewDate = getAppField(
    application,
    ['interview_date', 'last_interview_date', 'last_interview_assessment', 'last_interview'],
    ''
  );
  const interviewDate = formatInterviewDate(rawInterviewDate, lang) || rawInterviewDate;
  const hasInterviewDate = Boolean(interviewDate && interviewDate !== 'N/A');
  const applicationNo = formatApplicationNo(application);

  return (
    <div className="application-waiting-page">
      <div className="application-waiting-card">
        <div className="application-waiting-icon" aria-hidden="true">✓</div>
        <h1>{ta.waitingTitle}</h1>
        <p className="application-waiting-lead">{ta.waitingLead}</p>

        <div className="application-waiting-details">
          {applicationNo !== '—' && (
            <div className="application-waiting-detail">
              <span>{ta.waitingApplicationNo}</span>
              <strong>{applicationNo}</strong>
            </div>
          )}
          <div className="application-waiting-detail">
            <span>{ta.waitingInterviewLabel}</span>
            <strong>{hasInterviewDate ? interviewDate : ta.waitingInterviewPending}</strong>
          </div>
        </div>

        <p className="application-waiting-note">
          {hasInterviewDate ? ta.waitingNoteScheduled : ta.waitingNote}
        </p>

        <div className="application-waiting-actions">
          {typeof onGoToMessages === 'function' && (
            <button type="button" className="apply-btn application-waiting-primary" onClick={onGoToMessages}>
              {ta.waitingGoMessages}
            </button>
          )}
        </div>

        {typeof onBack === 'function' && (
          <button type="button" className="application-waiting-back" onClick={onBack}>
            {ta.waitingBackHome}
          </button>
        )}
      </div>
    </div>
  );
};

export default ApplicationWaiting;
